<template>
  <div>
    <pdf :src="finalReportUrl"
         :page="currentPage"
         @num-pages="pageCount=$event"
         @page-loaded="currentPage=$event"
         @loaded="loadPdfHandler"></pdf>
    <Page class-name="page" :current="currentPage" :total="pageCount" :page-size="1" @on-change="pageNumChange"/>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  components: {pdf},
  props: {
    previewUrls: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      $vue: '',
      finalReportUrl: '',
      currentPage: 1, // pdf文件页码
      pageCount: 0 // pdf文件总页数
    }
  },
  beforeMount () {
    this.$vue = this
    this.getPageData()
  },
  methods: {
    getPageData () {
      this.finalReportUrl = this.previewUrls.toString().split(',')[0]
      this.pageCount = this.previewUrls.toString().split(',').length
    },
    // pdf加载时
    loadPdfHandler (e) {
      this.currentPage = 1 // 加载的时候先加载第一页
      if (this.previewUrls.toString().indexOf(',') === 1) {
        this.pageCount = this.previewUrls.toString().split(',').length
      }
      console.log(this.pageCount)
    },
    // 改变页码
    pageNumChange (pageNum) {
      this.currentPage = pageNum
      if (this.previewUrls.toString().indexOf(',') === 1) {
        this.finalReportUrl = this.previewUrls.toString().split(',')[pageNum - 1]
      }
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .page
    margin-top 10px
    text-align center
</style>



// WEBPACK FOOTER //
// src/components/base/report/Report.vue